// ===========================================
// Roadmap Tab Component
// ===========================================
// Displays project roadmap in a Kanban board view

import React from 'react';
import { Plus } from 'lucide-react';
import RoadmapKanban from '../RoadmapKanban';

const RoadmapTab = ({ project, onAddMilestone, onEditMilestone }) => {
  // Get project ID (handle both id and _id)
  const projectId = project._id || project.id;
  
  return (
    <div className="project-detail__roadmap">
      {/* Header with add button */}
      <div className="section-header">
        <h3>Roadmap ({project.roadmap?.length || 0} requests)</h3>
        <button className="btn-primary" onClick={onAddMilestone}>
          <Plus size={16} /> Add Request
        </button>
      </div>
      
      {/* Kanban Board - drag & drop roadmap management */}
      <RoadmapKanban 
        roadmap={project.roadmap || []}
        projectId={projectId}
        onAddMilestone={() => onAddMilestone()}
        onEditMilestone={onEditMilestone}
      />
    </div>
  );
};

export default RoadmapTab;

